import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { LogDeviceWhitelist, LogDeviceWhitelistForm } from './LogDeviceWhitelistForm';
import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { useIntl } from 'react-intl';
import { useRef } from 'react';
import { useAddDeviceMutation, useUpdateDeviceMutation } from '../../../../../services/logDeviceWhitelistCm4Tbm3Api';
import { useAddOcu3Mutation, useUpdateOcu3Mutation } from '../../../../../services/logDeviceWhitelistOcu3Api';

import Notification from '@rio-cloud/rio-uikit/Notification';
import { DEVICE_TYPE } from '../../device-sidebar/device-state.types';

interface LogDeviceWhitelistFormDialogProps {
    preSelectedType: DEVICE_TYPE;
    show: boolean;
    edit?: LogDeviceWhitelist;
    onClose: VoidFunction;
}

export const LogDeviceWhitelistFormDialog = ({
    preSelectedType,
    show,
    edit,
    onClose,
}: LogDeviceWhitelistFormDialogProps) => {
    const { formatMessage } = useIntl();
    const formRef = useRef<{ submitForm: () => void } | null>(null);
    const [addLogDeviceWhitelistCm4] = useAddDeviceMutation();
    const [updateLogDeviceWhitelistCm4] = useUpdateDeviceMutation();
    const [addLogDeviceWhitelistTbm3] = useAddDeviceMutation();
    const [updateLogDeviceWhitelistTbm3] = useUpdateDeviceMutation();
    const [addLogDeviceWhitelistOcu3] = useAddOcu3Mutation();
    const [updateLogDeviceWhitelistOcu3] = useUpdateOcu3Mutation();

    const onConfirm = () => {
        if (formRef.current) {
            formRef.current.submitForm();
        }
    };

    const handleFormSubmit = async (formData: LogDeviceWhitelist) => {
        try {
            if (!!edit) {
                if (formData.type === DEVICE_TYPE.CM4) {
                    await updateLogDeviceWhitelistCm4(formData).unwrap();
                    Notification.info('Successfully updated');
                }
                if (formData.type === DEVICE_TYPE.TBM3) {
                    await updateLogDeviceWhitelistTbm3(formData).unwrap();
                    Notification.info('Successfully updated');
                }
                if (formData.type === DEVICE_TYPE.OCU3) {
                    await updateLogDeviceWhitelistOcu3(formData).unwrap();
                    Notification.info('Successfully updated');
                }
            } else {
                if (formData.type === DEVICE_TYPE.CM4) {
                    formData.originator = `${formData.type.toLowerCase()}:${formData.serial_number}`;
                    await addLogDeviceWhitelistCm4(formData).unwrap();
                }
                if (formData.type === DEVICE_TYPE.TBM3) {
                    formData.originator = `${formData.type.toLowerCase()}:${formData.serial_number}`;
                    await addLogDeviceWhitelistTbm3(formData).unwrap();
                }
                if (formData.type === DEVICE_TYPE.OCU3) {
                    await addLogDeviceWhitelistOcu3(formData).unwrap();
                }
                Notification.info('Successfully created');
            }
        } catch (e: unknown) {
            if (typeof e === 'object' && e !== null && 'status' in e && 'data' in e) {
                const error = e as { status: number; data?: { detail?: string } };
                if (error.status === 400) {
                    Notification.warning(error.data?.detail);
                }
                return;
            }
            Notification.error(`Could not ${!!edit ? 'update' : 'create'}`);
        } finally {
            onClose();
        }
    };

    return (
        <ConfirmationDialog
            useOverflow
            show={show}
            bsSize={Dialog.SIZE_XL}
            onClickConfirm={onConfirm}
            onClickCancel={onClose}
            title={formatMessage({ id: 'intl-msg:coreconAdminWeb.logDeviceWhitelist.form' })}
            content={
                <LogDeviceWhitelistForm
                    preSelectedType={preSelectedType}
                    ref={formRef}
                    edit={edit}
                    onSubmit={handleFormSubmit}
                />
            }
            confirmButtonText={
                <>
                    <span className="rioglyph rioglyph-ok margin-right-5" />
                    <span>{formatMessage({ id: 'intl-msg:coreconAdminWeb.confirm' })}</span>
                </>
            }
            cancelButtonText={formatMessage({ id: 'intl-msg:coreconAdminWeb.cancel' })}
        />
    );
};